export default "__VITE_ASSET__Dh$d07z5__"